import React, { useState } from "react";
import styled from "styled-components";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { MethodFilterItems } from "./FilterItems";

const StyledWrapper = styled.div`
  width: 200px;
  height: 35px;
`;

const FilterBtnWrapper = styled.div`
  width: 185px;
  height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FilterItemWrapper = styled.div`
  width: 208px;
  height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const StyledArrowDownIcon = styled(ArrowDropDownIcon)`
  && {
    margin-left: 8px;
  }
`;

const StyledBtn = styled.button`
  margin: 4px;
  padding: 3px 8px;
  border: 1px solid #939fa5;
  border-radius: 4px;
  display: flex;
  font-weight: 500;
  font-size: 11px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: white;

  &:hover {
    border-color: #2196f3;
  }
`;

const StyledFilterWrapper = styled.div`
  width: 98px;
  height: auto;
`;

// type FilterArray = string[];

export default function FilterBtns() {
  const [openMethods, setMethods] = useState(false);

  // const methods: FilterArray = ["밀링", "선반"];
  // const materials: FilterArray = [
  //   "알루미늄",
  //   "탄소강",
  //   "구리",
  //   "합금강",
  //   "강철",
  // ];

  return (
    <StyledWrapper>
      <FilterBtnWrapper>
        <StyledBtn
          name={"method"}
          onClick={() => {
            setMethods(!openMethods);
          }}
        >
          가공방식
          <StyledArrowDownIcon />
        </StyledBtn>
        {}
      </FilterBtnWrapper>
      {}

      <FilterItemWrapper>
        <StyledFilterWrapper>
          {openMethods && <MethodFilterItems />}
        </StyledFilterWrapper>
      </FilterItemWrapper>
    </StyledWrapper>
  );
}

// type FilterBtnProps = {
//   text: string;
//   onClick: React.MouseEventHandler<HTMLButtonElement>;
// };
